export default "__VITE_ASSET__DwvnVFl8__"